function getStepPublishSelectors(state) {
  const publish = state.stepPublishProf;

  return {
    formValues: {
      branches: publish.formValues.branches,
      usersAllowed: publish.formValues.usersAllowed,
      availableCredits: publish.formValues.availableCredits,
      comercialInfo: publish.formValues.comercialInfo,
      currentResponsible: publish.formValues.currentResponsible,
      currentBranch: publish.formValues.currentBranch,
      commissionShare: publish.formValues.commissionShare
    },
    formValuesError: publish.formValuesError,
    formValuesLoading: publish.loadinFormValues,
    formValuesCompleted: publish.formValuesCompleted,
    isZonaDemandLocation: publish.isZonaDemandLocation
  };
}

export { getStepPublishSelectors };
